module.exports = __webpack_public_path__ + "img/multi_robo2.4fa23b92.svg";